/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-06 10:31:31                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-11-06 10:31:31                               *
 *****************************************************************************/

import { useEffect, useState } from "react";
import { t } from "../../../i18n";
import MultiCheckSelect from "../../option-select/MultiCheckSelect";
import { reactSelectTheme } from "../../option-select/reactSelectTheme";

interface CustomerTypeSelectProps {
    value?: string[],
    onChange?: (values: string[]) => void,
    disabled?: boolean
}

/*
 * CustomerTypeSelect: workorder status select component
 * Used to select a workorder status for a workorder
*/
const CustomerTypeSelect = (props: CustomerTypeSelectProps) => {
  const [customerTypeListState, setCustomerTypeListState] = useState<any[]>([]);
  const [valueState, setValueState] = useState<any>(null);

  useEffect(() => {
    const list = [
      "PROSPECT",
      "ACTIVE",
      "INACTIVE"
    ];
 
    setCustomerTypeListState(list.map((e) => {
      return {value: e, label: t("client:type."+e.toLowerCase())};
    }));

    if (props.value) {
      setValueState(props.value.map((val) => {
        return {value: val, label: t("client:type."+val.toLowerCase())};
      }));
    }
  }, [props.value]); // get customerType list

  const customerTypeChange = ((value: any) => {
    setValueState(value);
    if (props.onChange)  
      props.onChange(value.map((val: {value: string, label: string}) => {
        return val.value;
      }));
  });

  return (
    <div className="flex">
      <MultiCheckSelect options={customerTypeListState}
        value={valueState}
        theme={reactSelectTheme}
        onChange={customerTypeChange}
        name="customerType"
        placeholder={t("common:selectCustomerType")}
        className="w-full mr-2"
        isDisabled={props.disabled} />
    </div>
  );
};

export default CustomerTypeSelect;
